import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from './utils/axios';
import moment from 'moment-timezone';
import '@/assets/tailwind.css';

import HeroHeader from '@/components/common/HeroHeader.vue';
import LoadingSvg from '@/components/svgs/LoadingSvg.vue';
const app = createApp(App);
app.use(store);
app.use(router);

app.component('HeroHeader', HeroHeader);
app.component('LoadingGlobal', LoadingSvg);
app.provide('$moment', moment);
app.provide('$router', router);
app.provide('$axios', axios);
app.provide('$store', store);
app.mount('#app');
